"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImageToFill = exports.isAutofillProject = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
const autofillProjectRuleSet = {
  type: value => value === 'AUTOFILL_PROJECT',
  imagesToFill: val => Array.isArray(val) && val.every(curr => (0, exports.isImageToFill)(curr)),
  mobile: typeguard_1.isBool,
  fromScratch: typeguard_1.isBool
};
const isAutofillProject = p => (0, ProjectAction_1.isBaseProjectAction)(p) && (0, typeguard_1.isType)(p, autofillProjectRuleSet);
exports.isAutofillProject = isAutofillProject;
const imageToFillRuleset = {
  galleryId: typeguard_1.isNonEmptyString,
  galleryImageId: typeguard_1.isNonEmptyString,
  width: typeguard_1.isNumber,
  height: typeguard_1.isNumber
};
const isImageToFill = p => (0, typeguard_1.isType)(p, imageToFillRuleset);
exports.isImageToFill = isImageToFill;